// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__u19dR","title":"PageNotFound_title__r4MCh","goBack":"PageNotFound_goBack__TQpf4"};